module.exports = __webpack_public_path__ + "img/figuur.c.e7712bb5.svg";